import ActionTypeContrato from "../ActionTypeContrato";

export default class BuscarContratos extends ActionTypeContrato{
    ejecutar(estado, nuevoEstado) {    
        nuevoEstado.flag.procesandoComando = true;
        // nuevoEstado.flag.sensorDeAccionABuscar = !(estado.flag.sensorDeAccionABuscar);
        return nuevoEstado;
    }
}